/*
  Над вкладками справочника судов: по скольким домам заявления не соберутся и почему.

  🔴 Решение владельца 02.11.2026 (вариант А макетов). До него здесь стояло «Не
  привязано к участкам помещений: N» - счёт только своих записей. С общим справочником
  платформы дом без своей записи участок уже имеет, и прежнее число пугало бы домами,
  по которым заявление уходит. Теперь три причины, и каждую можно отобрать вкладкой
  на «Подсудности домов»: нет протокола, участок уточняется, ещё не проверен. С
  03.11.2026 четвёртая - помещения без адреса дома: они стоят строкой на той же вкладке.

  Стоит НАД вкладками, как прежнее предупреждение (решение владельца 14.09.2026): оно
  относится ко всему справочнику, а не к одной таблице. Откуда участок, не говорится.
*/

import { plural } from '../api/format.js'
import { Notice } from './Common.jsx'

const houses = (count) => plural(count, 'дом', 'дома', 'домов')
// «1 дом ещё не проверен», «21 дом ещё не проверен», но «2 дома ещё не проверены».
const checked = (count) => (count % 10 === 1 && count % 100 !== 11 ? 'проверен' : 'проверены')

export default function CourtHousesNotice({ summary }) {
  if (!summary) return null
  const { no_protocol: bare, disputed, unchecked } = summary
  // Помещения без адреса дома («Кв. 64», 03.11.2026) домами не считаются, но и
  // заявлений по ним нет - пропади они отсюда, предупреждение занизило бы потерю.
  const homeless = summary.no_house?.premises ?? 0
  const total = bare.houses + disputed.houses + unchecked.houses
  if (!total && !homeless) return null
  const premises = bare.premises + disputed.premises + unchecked.premises + homeless

  const reasons = [
    bare.houses ? `${houses(bare.houses)} без протокола собрания` : null,
    disputed.houses ? `${houses(disputed.houses)} - участок уточняется` : null,
    unchecked.houses
      ? `${houses(unchecked.houses)} ещё не ${checked(unchecked.houses)}`
      : null,
    homeless
      ? `${plural(homeless, 'помещение', 'помещения', 'помещений')} без адреса дома`
      : null,
  ].filter(Boolean)

  return (
    <Notice kind="warn" wide>
      <div>
        Заявления не соберутся по{' '}
        {plural(premises, 'помещению', 'помещениям', 'помещениям')}
        {/* «в N домах» - только когда все помещения в домах: иначе прочлось бы, что и
            помещения без адреса дома стоят в этих домах. */}
        {total && !homeless ? <> в {plural(total, 'доме', 'домах', 'домах')}</> : null}.
      </div>
      <div className="muted">
        {reasons.join(' · ')}. Отберите нужное на вкладке «Подсудность домов».
      </div>
    </Notice>
  )
}
